<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="GRI编码" prop="fiveBitCode">
                    <el-input v-model="queryCondition.fiveBitCode" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="GRI名称" prop="fiveBitCodeName">
                    <el-input v-model="queryCondition.fiveBitCodeName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category2" prop="categoryLevel2CodeList">
                    <el-select v-model="queryCondition.categoryLevel2CodeList" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%">
                      <el-option v-for="item in categoryList2" :label="item.name" :value="item.code" :key="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="工厂名称" prop="facilityName">
                    <el-input v-model="queryCondition.facilityName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="最新检测日期从" prop="lastInspectDateBegin">
                      <el-date-picker v-model="queryCondition.lastInspectDateBegin" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="最新检测日期至" prop="lastInspectDateEnd">
                      <el-date-picker v-model="queryCondition.lastInspectDateEnd" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                      <ic-select table="TT_NUTR_INGREDIENT" field="STATUS" clearable v-model="queryCondition.status" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onSave" :disabled="isSDisabled" :loading="isSLoading">选择</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onCancel">取消</el-button>
      </el-row>
      <el-row>
        <el-table :data="tableData" @selection-change="handleSelectionChange" max-height="425" border stripe style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="fiveBitCode" sortable show-overflow-tooltip label="GRI编码" width="130"></el-table-column>
          <el-table-column prop="fiveBitCodeName" sortable show-overflow-tooltip label="GRI名称" width="150"></el-table-column>
          <el-table-column prop="describe" sortable show-overflow-tooltip label="GRI描述" width="150"></el-table-column>
          <el-table-column prop="facilityName" sortable show-overflow-tooltip label="工厂名称" width="150"></el-table-column>
          <el-table-column prop="categoryLevel2Name" sortable show-overflow-tooltip label="Category2" width="120"></el-table-column>
          <el-table-column prop="cookCodeText" sortable show-overflow-tooltip label="烹饪方式" width="120"></el-table-column>
          <el-table-column prop="statusText" sortable show-overflow-tooltip label="状态" width="90"></el-table-column>
          <el-table-column prop="lastInspectDate" sortable show-overflow-tooltip label="最新检测日期" width="150"></el-table-column>
          <el-table-column prop="inspectLabCodeText" sortable show-overflow-tooltip label="检测实验室" width="180"></el-table-column>
          <el-table-column prop="remark" sortable show-overflow-tooltip label="备注" width="180"></el-table-column>
          <el-table-column prop="updateDate" sortable show-overflow-tooltip label="更新日期" width="150"></el-table-column>
          <el-table-column prop="updateByName" sortable show-overflow-tooltip label="更新人" width="150"></el-table-column>
          <el-table-column prop="createDate" sortable show-overflow-tooltip label="创建日期" width="150"></el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
          </el-pagination>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
import nutriApi from "@/api/Nutrition/index";
import paginationMixin from '@/mixins/pagitionMixin';
import { apiService } from "@/api/material/material-master-data";
import { fileService } from "@/api/common/file-utils";
import IcSelect from "@/components/common/icSelect";
export default {
  // name: 'Window',
  mixins: [paginationMixin],
  components: { IcSelect },
  props: ['addInfo'],
  data() {
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        fiveBitCode: "",
        fiveBitCodeName: "",
        categoryLevel2CodeList: [],
        facilityName: "",
        status: "",
        lastInspectDateBegin: "",
        lastInspectDateEnd: "",
      },
      totalCount: 0,
      pages: 1,
      isShow: false,
      isSDisabled: false,
      isSLoading: false,
      tableData: [],
      categoryList2: [],
      multipleSelection: [],
    };
  },
  watch: {
    addInfo: {
      handler(newV, oldV) {
        console.log("🚀 ~ file: nutritionAdd.vue:126 ~ handler ~ newV:", JSON.parse(newV))
        if (newV) {
          this.tableData = JSON.parse(newV).resultData
          this.totalCount = JSON.parse(newV).totalCount
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getCategory1()
  },
  methods: {
    queryData() {
      nutriApi.findNutritionAddQuery(this.queryCondition).then((res) => {
        console.log("🚀 ~ file: nutritionAdd.vue:150 ~ nutriApi.findNutritionAddQuery ~ res:", res)
        if (res) {
          this.tableData = res.resultData
          this.totalCount = res.totalCount
        }
      }).catch(error => {
        console.log("🚀 ~ file: nutritionDetection.vue:451 ~ nutriApi.findNutritionAddQuery ~ error:", error.response)
      })
    },
    getCategory1() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        var pid
        res.data.forEach(ele => {
          if (ele.code == '10' && ele.name == 'Food') {
            pid = ele.tmCategoryId
          }
        })
        this.getCategory2(pid)
      });
    },
    getCategory2(pid) {
      apiService.findCategory({ categoryLevel: 2, pid: pid }).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:507 ~ apiService.findCategory ~ res:", res)
        this.categoryList2 = res.data;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.ingredientIdList = []
      val.forEach(ele => {
        this.ingredientIdList.push(ele.ingredientId)
      })
      console.log("🚀 ~ file: ingredient.vue:322 ~ handleSelectionChange ~ this.ingredientIdList:", this.ingredientIdList)
    },
    onSave() {
      this.isSDisabled = true
      this.isSLoading = true
      nutriApi.saveInspectAdd({
        idList: this.ingredientIdList
      }).then((res) => {
        this.isSDisabled = false
        this.isSLoading = false
        console.log("🚀 ~ file: nutritionAdd.vue:168 ~ onSave ~ res:", res)
        if (res.code == '200') {
          this.$message.success('操作成功')
          this.$emit('setParam')
          this.queryCondition = {
            pageSize: 15,
            pageNum: 1,
            fiveBitCode: "",
            fiveBitCodeName: "",
            categoryLevel2CodeList: [],
            facilityName: "",
            status: "",
            lastInspectDateBegin: "",
            lastInspectDateEnd: "",
          }
        }
      }).catch(error => {
        this.isSDisabled = false
        this.isSLoading = false
        console.log("🚀 ~ error.response:", error.response)
      })
    },
    onSearch() {
      this.queryCondition.pageNum = 1;
      this.queryData()
    },
    onReset() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        fiveBitCode: "",
        fiveBitCodeName: "",
        categoryLevel2CodeList: [],
        facilityName: "",
        status: "",
        lastInspectDateBegin: "",
        lastInspectDateEnd: "",
      }
      this.queryData()
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onCancel() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        fiveBitCode: "",
        fiveBitCodeName: "",
        categoryLevel2CodeList: [],
        facilityName: "",
        status: "",
        lastInspectDateBegin: "",
        lastInspectDateEnd: "",
      }
      this.$emit('closeAdd')
    },
  }
}
</script>
  